import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import { HouseLoginEiendomsverdi } from "./HouseLoginEiendomsverdi";
import { HouseLoginStandard } from "./HouseLoginStandard";

interface Props {
  productBackendName: ProductBackendName;
}

export const HouseLogin = ({
  productBackendName,
}: Props): React.ReactElement => {
  const featureToggleEiendomsverdi = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_15_eiendomsverdi,
  );

  if (featureToggleEiendomsverdi) {
    return <HouseLoginEiendomsverdi productBackendName={productBackendName} />;
  }
  return <HouseLoginStandard productBackendName={productBackendName} />;
};
